import { render, staticRenderFns } from "./NickName.vue?vue&type=template&id=806f559e&scoped=true"
import script from "./NickName.vue?vue&type=script&lang=js"
export * from "./NickName.vue?vue&type=script&lang=js"
import style0 from "./NickName.vue?vue&type=style&index=0&id=806f559e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806f559e",
  null
  
)

export default component.exports